module.exports = __webpack_public_path__ + "img/house-3.48bc17bc.jpg";